import React from 'react';
import { observer } from 'mobx-react-lite';
import { Form, InputNumber, Slider } from 'antd';
import QuickTurnBoltStore from 'stores/QuickTurnBoltStore';
import MinAndMaxDimensions from '../MinAndMaxDimensions';

const ThreadLength = () => {
    const { shaft_length, thread_length } = QuickTurnBoltStore;

    function handleChangeThreadLength(value: number): void {
        QuickTurnBoltStore.updateBoltById(QuickTurnBoltStore.boltToken, { thread_length: value });
    }

    const minThreadLength = () => {
        return Number((0.25).toFixed(3));
    };

    const maxThreadLength = () => {
        return Number((shaft_length - 0.1).toFixed(3));
    };

    function onChangeThreadLength(value: number) {
        if (value >= minThreadLength() && value <= maxThreadLength()) {
            QuickTurnBoltStore.setThreadLength(value);
        }
    }

    return (
        <Form.Item label="Thread Length (in.)" className="mb-0">
            <div className="d-flex flex-row align-items-center" style={{ columnGap: '20px' }}>
                <div className="d-flex flex-column flex-grow-1">
                    <Slider
                        className="w-100 m-0 my-2"
                        min={minThreadLength()}
                        max={maxThreadLength()}
                        step={0.001}
                        tooltip={{
                            formatter: (value?: number) => `${value?.toFixed(3)}`,
                        }}
                        onChange={(value: number) => {
                            onChangeThreadLength(value);
                        }}
                        onAfterChange={(value: number) => {
                            onChangeThreadLength(value);
                            handleChangeThreadLength(value);
                        }}
                        value={thread_length}
                    />
                    <MinAndMaxDimensions min={minThreadLength()} max={maxThreadLength()} unit="inch" />
                </div>
                <InputNumber
                    min={minThreadLength()}
                    max={maxThreadLength()}
                    value={thread_length}
                    precision={3}
                    step={0.001}
                    onChange={value => {
                        if (value) {
                            onChangeThreadLength(value);
                            handleChangeThreadLength(value);
                        }
                    }}
                    style={{ width: '100px' }}
                    className="LoNotSensitive"
                />
            </div>
        </Form.Item>
    );
};

export default observer(ThreadLength);
